import { Div, Collection, CollectionPrinter } from "@tblabs/truffle";
import { Icons } from "../Components/Utils/Icons";
import { DefaultIconButton } from "../Components/Utils/XPrimaryButton";
import { BasketItem } from "../Models/Basket/BasketItem";
import { ShopContent } from "../Shop/ShopContent";
import { AddRentItemWindow, AddSaleItemWindow } from "./AddRentItemWindow";
import { AdminBasketTableItem } from "./Admin/OrdersView/Views/Table/Components/BasketTableItem";


export class TicketBasketList extends Div
{
    constructor(shop: ShopContent, basketItems: Collection<BasketItem>)
    {
        super();

        this.Append(
            new CollectionPrinter(basketItems, item => new AdminBasketTableItem(item)),
            new DefaultIconButton("Dodaj wynajem", Icons.Plus, () => new AddRentItemWindow(shop, basketItems)),
            new DefaultIconButton("Dodaj sprzedaż", Icons.Plus, () => new AddSaleItemWindow(shop, basketItems))
        );
    }
}
